// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconStoreFactory = createRemixIcon('IconStoreFactory', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .75H.75v22.5h22.5V5.846l-1.87 1.069l-5.13 2.931v-4l-1.87 1.069l-5.13 2.931V.75zm1.25 20V3.25h3.5v10.904l1.87-1.069l5.13-2.931v4l1.87-1.069l5.13-2.931V20.75H9.25V17h-3.5v3.75z\" clip-rule=\"evenodd\"/>");
